import type { JentisParameter } from './types';
import { COUNTRY_ISO } from '../../i18n';

export const JENTIS_COUNTRY_MAP: Record<string, JentisParameter> = {
  AT: {
    host: 'https://5nk3ky.pixum.at',
    project: 'pixumat',
    fileName: 'v727af.js'
  },
  DE: {
    host: 'https://gmm9n9.pixum.de',
    project: 'pixum-de',
    fileName: '9yz82f.js'
  },
  CH: {
    host: 'https://8f2wxb.pixum.ch',
    project: 'pixum-ch',
    fileName: '93ueft.js'
  },
  DK: {
    host: 'https://wifi4k.pixum.dk',
    project: 'pixumdk',
    fileName: '2szgcn.js'
  },
  FR: {
    host: 'https://je9qpq.pixum.fr',
    project: 'pixumfr',
    fileName: 'n8g27f.js'
  },
  IT: {
    host: 'https://fbbdcn.pixum.it',
    project: 'pixumit',
    fileName: '24s4tq.js'
  },
  ES: {
    host: 'https://ncg5it.pixum.es',
    project: 'pixumes',
    fileName: 'atdr16.js'
  },
  NL: {
    host: 'https://2enzq5.pixum.nl',
    project: 'pixumnl',
    fileName: 'd9cwi5.js'
  },
  SE: {
    host: 'https://apwr58.pixum.se',
    project: 'pixumse',
    fileName: 'ujigr6.js'
  },
  LU: {
    host: 'https://3c3kss.pixum.lu',
    project: 'pixumlu',
    fileName: '96m72t.js'
  },
  GB: {
    host: 'https://tcan97.pixum.co.uk',
    project: 'pixumuk',
    fileName: 'a56nyu.js'
  },
  PL: {
    host: 'https://m5eyrh.pixum.pl',
    project: 'pixum_pl',
    fileName: '11r55u.js'
  },
  BG: {
    host: 'https://94g5px.pixum.bg',
    project: 'pixum_bg',
    fileName: '9j1uon.js'
  },
  CZ: {
    host: 'https://asixwf.pixum.cz',
    project: 'pixum_cz',
    fileName: 'adh3oo.js'
  },
  HU: {
    host: 'https://mynfko.pixum.hu',
    project: 'pixum_hu',
    fileName: 'tt8ggk.js'
  },
  BE: {
    host: 'https://5fixu6.pixum.be',
    project: 'pixumbe',
    fileName: 'q77k4r.js'
  },
  FI: {
    host: 'https://2r488q.pixum.fi',
    project: 'pixumbe',
    fileName: 'cc158i.js'
  }
};

/**
 * Countries excluded from Jentis tracking
 * - PT, IE: No Jentis setup
 * - PL, BG, CZ, HU: Temporarily excluded until proper Jentis projects are configured
 *   (currently using UK config which causes 'iframe' errors)
 * TODO: Remove PL, BG, CZ, HU from exclusion list once Jentis team sets up dedicated projects
 */
export const JENTIS_COUNTRIES_EXCLUDED = ['PT', 'IE', 'EN'];

export const JENTIS_COUNTRIES = Object.values(COUNTRY_ISO).filter(code => !JENTIS_COUNTRIES_EXCLUDED.includes(code));

export const JENTIS_PENDING_IDENTIFIER = 'pendingJentisTracking';

export const TRACKING_CATEGORIES = {
  HEADER: 'Header',
  BRAND_BAR: 'Brandleiste',
  FOTOBUCH: 'Fotobuch',
  JUMP_LINK: 'Sprungmarke'
};

export const TRACKING_ACTIONS = {
  SERVICE: 'Service',
  LOGO: 'Logo',
  CLOSING: 'Schliessen',
  OPENING: 'oeffnen',
  LOGIN: 'Anmelden',
  CART: 'Warenkorb',
  SCROLLING: 'Scrolling',
  LANGUAGE_SWITCHER: 'Language Switcher',
  DL_MODAL: 'DL-Modal'
};

export const TRACKING_LABELS = {
  SHOW: 'Show',
  CLOSE: 'Close'
};

export const JENTIS_PAGE_TYPES = {
  productList: 'productlist',
  productDetail: 'productdetail',
  service: 'service',
  home: 'home',
  checkout: 'checkout',
  landingpage: 'landingpage',
  productGrid: 'productGrid',
  content: 'content'
};

export const JENTIS_USER = {
  SessionId: 'jentis_session_id',
  UserId: 'jentis_user_id'
};
